module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter_title"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "pg18lev1"
    }
  }), _vm._v("PRESERVED KUMQUAT VINAIGRETTE")]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("Preserved kumquats, salty and tart-sweet, make a great vinaigrette. I like the combination of kumquats, shallots, and serrano chiles here. Use this dressing for just about any salad.")]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("MAKES ABOUT "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" CUP (120 ML)")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublistt"
  }, [_c('em', [_vm._v("4 preserved kumquats with lime and chile "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#pg17lev1"
    }
  }, [_vm._v("(page 17)")]), _vm._v(", finely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_vm._v("2 small shallots, finely chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_vm._v("12 thin slices serrano chile (or adjust to desired spiciness)")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_vm._v("Juice of 2 lemons")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_vm._v("Juice of 2 limes")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" cup [60 ml] extra-virgin olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_c('em', [_vm._v("Fresh black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Mix the kumquats, shallots, and chiles in a small bowl. Whisk in the lemon juice, lime juice, and olive oil. Add several grinds of black pepper and whisk to combine. Serve immediately or store in a covered container in the refrigerator for up to 1 week.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0019-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f24b6e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10chapter03.vue
// module id = 87
// module chunks = 0